import { ApiGigInvitesDto } from "../api/models/api/gig";
import { GigInvitesDto } from "../api/models/gig";


export const mapFromApiGigInvitesDto = (apiDto: ApiGigInvitesDto): GigInvitesDto => ({
    ...apiDto,
    id: apiDto.gigInviteId
});